<template>
    <div class="toolsActivityEdit form">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
            <div class="activityMsgBox">
                <div class="title"><p>活动信息</p></div>
                <div class="contentBox">
                    <div class="left">
                        <el-form-item label="活动来源" required>
                            <el-radio-group v-model="ruleForm.eventsource">
                                <el-radio :label="1">自定义</el-radio>
                                <el-radio :label="2" @click.native="choiceShop" :disabled="true">已有内容</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="活动主图" required class="cover" prop="coveratturlid">
                            <div class="imgBox">
                                <i class="el-icon-picture" v-if="!ruleForm.coveratturlidImg"></i>
                                <img class="activityCoverImage" :src="ruleForm.coveratturlidImg.furl + '?' + time" v-else-if="ruleForm.coveratturlidImg && ruleForm.coveratturlidImg.furl + '?' + time" alt="">
                            </div>
                            <div class="uploadFileBox">
                                <!-- <UploadFile :uploadType="uploadVideoType" @setFile="setFile" :fileRule="fileRule"></UploadFile> -->
                                <el-button @click.native="openDialog">选择文件</el-button>
                                <p>建议尺寸750*420px的JPG、PNG格式， 图片小于2M。</p>
                            </div>
                        </el-form-item>
                        <el-form-item label="活动标题" prop="title">
                            <el-input v-model="ruleForm.title" maxlength="40" show-word-limit placeholder="输入活动标题，不超过40个字"></el-input>
                        </el-form-item>
                        <el-form-item label="活动副标题" prop="subtitle">
                            <el-input v-model="ruleForm.subtitle" maxlength="100" show-word-limit placeholder="输入副活动标题，不超过100个字"></el-input>
                        </el-form-item>
                        <el-form-item label="活动开始时间" prop="begintime" required>
                            <!-- class="date" -->
                            <!-- <el-date-picker id="datePicker" v-model="ruleForm.date" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker> -->
                            <el-date-picker v-model="ruleForm.begintime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" :disabled="isBegin" type="datetime" placeholder="选择活动开始时间"></el-date-picker>
                            <!-- <span class="to">至</span> -->
                        </el-form-item>
                        <el-form-item label="活动结束时间" prop="endtime" required>
                            <el-date-picker v-model="ruleForm.endtime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择活动结束时间"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="商品总库存" prop="stockcount" required>
                            <el-input v-model="ruleForm.stockcount" placeholder="输入商品总库存"></el-input><span class="inputTips">0 为不限制</span>
                        </el-form-item>
                        <!-- <el-form-item label="最多购买次数">
                            <el-input v-model="ruleForm.maxbuycount" placeholder="同一用户最多购买次数，留空则默认为1"></el-input><span class="inputTips">若商品类型来源于内容，则同一用户只能买 1 次</span>
                        </el-form-item> -->
                        <!-- <el-form-item label="是否显示排行榜">
                            <el-switch v-model="ruleForm.isdisplayrank"></el-switch>
                            <span class="showRankingListTips">开启后将显示分销排行榜信息</span>
                        </el-form-item> -->
                        <el-form-item label="活动详情" prop="eventdesp">
                            <uEditor :content="ruleForm.eventdesp" ref="uEditor1" @getUEditorContent="getTrySeeContent"></uEditor>
                        </el-form-item>
                    </div>
                    <div class="right">
                        <div class="topBox">
                            <img class="top" :src="require('@/common/images/toolmgt/view-top.png')" alt="">
                        </div>
                        <div class="innerBox">
                            <div class="coverImgBox">
                                <img class="activityCoverImage" :src="ruleForm.coveratturlidImg.furl + '?' + time" v-if="ruleForm.coveratturlidImg && ruleForm.coveratturlidImg.furl + '?' + time" alt="">
                            </div>
                            <div class="priceBox" v-if='ruleForm.asstype !== 1'>
                                <p class="price">￥{{ruleForm.saleprice}}</p>
                                <!-- <p class="outofprint">已售{{ruleForm.fakesalecount === '' ? 0 : ruleForm.fakesalecount}}</p> -->
                                <p class="outofprint">已售 0</p>
                            </div>
                            <!-- 阅读助力下不显示 -->

                            <div class="rightTitleBox">
                                <p class="rightTitle">{{ruleForm.title === '' ? '活动名称' : ruleForm.title}}</p>
                                <p class="rightSubtitle">{{ruleForm.subtitle === '' ? '活动副标题' : ruleForm.subtitle}}</p>
                            </div>
                            <div class="detailsBox">
                                <p class="detailsTitle">商品详情</p>
                                <div class="detailsContent" v-html="ruleForm.eventdesp" v-if="ruleForm.eventdesp"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="distributionMsgBox">
                <div class="title"><p>助力参数</p></div>
                <div class="contentBox">
                    <el-form-item label="助力方式">
                        <p v-if="ruleForm.asstype == 1">阅读助力</p>
                        <p v-if="ruleForm.asstype == 2">公众号助力</p>
                        <p v-if="ruleForm.asstype == 3">砍价助力</p>
                    </el-form-item>
                    <el-form-item label="商品原价" prop="saleprice">
                        <el-input v-model="ruleForm.saleprice" placeholder="请输入商品实际价格" :disabled="isBegin"></el-input>
                    </el-form-item>
                    <el-form-item label="助力价格" prop="assprice">
                        <el-input v-model="ruleForm.assprice" placeholder="请输入助力价格" :disabled="isBegin"></el-input>
                    </el-form-item>
                    <el-form-item label="是否支持原价购买">
                        <el-switch v-model='ruleForm.isorgpricebuye' :disabled="isorgpricebuyeDisabled"></el-switch>
                        <span class="inputTips">开启后可原价直接购买，如果商品原价为0默认关闭</span>
                    </el-form-item>
                    <el-form-item label="可发起次数" prop="maxcreateasscount" class="distributionGrade" required>
                        <el-input-number v-model="ruleForm.maxcreateasscount" :min="0" @change="justMaxcreateasscount"></el-input-number>
                        <span class="inputTips">0为不限制发起助力</span>
                    </el-form-item>
                    <el-form-item v-if="ruleForm.asstype == 3" label="助力金额分配类型" prop="assmoneytype">
                        <el-radio-group v-model="ruleForm.assmoneytype" :disabled="isBegin">
                            <el-radio :label="1">随机分配</el-radio>
                            <el-radio :label="2">平均分配</el-radio>
                        </el-radio-group>
                        <p class="inputTips">发起助力后除自己砍价之外剩余的金额再按照所选方式分配</p>
                    </el-form-item>
                     <el-form-item v-if="ruleForm.asstype == 3" label="未完成可差价购买" prop="isfailbuy" class="distributionGrade">
                        <el-switch v-if="ruleForm.saleprice == 0" :disabled="true" v-model="ruleForm.isfailbuy"></el-switch>
                        <el-switch v-else v-model="ruleForm.isfailbuy"></el-switch>
                        <span class="inputTips">开启后可按照当时的砍到的价格购买</span>
                    </el-form-item>

                    <el-form-item label="参与的公众号" v-if="ruleForm.asstype == 2" prop="asstype">
                        <el-select v-model="ruleForm.joinappid" placeholder="选择公众号" :disabled="isBegin">
                            <el-option v-for="item in joinappidList" :key="item.appid" :label="item.name" :value="item.appid"></el-option>
                        </el-select>
                        <span @click='gotogzh' style="color: #409EFF;font-size: 14px; margin-left: 16px">新增公众号</span>
                    </el-form-item>
                    <!-- 公众号助力下开启 -->

                    <el-form-item label="助力人数" prop="minasscount" class="distributionGrade" required>
                        <el-input-number v-model="ruleForm.minasscount" :disabled="isBegin" :min="1"></el-input-number>
                    </el-form-item>

                    <el-form-item label="助力期限" prop="assexpiretype">
                        <el-radio-group v-model="ruleForm.assexpiretype">
                            <el-radio :label="1">与活动截止时间一致</el-radio>
                            <el-radio :label="2">发起助力后 <el-input :disabled="ruleForm.assexpiretype == 1" style="width: 94px" placeholder="填写整数" v-model="ruleForm.assexpiretime"></el-input> 小时</el-radio>
                        </el-radio-group>
                    </el-form-item>

                     <el-form-item label="完成后继续助力" prop="iscontinueass" class="distributionGrade" v-if="ruleForm.asstype !== 3">
                        <el-switch v-model="ruleForm.iscontinueass" @change="guanlian(1)" :disabled="iscontinueassstatus"></el-switch>
                        <span class="inputTips">开启排行榜必须开启</span>
                    </el-form-item>
                    <!-- 砍价助力下不展示 -->

                     <el-form-item label="是否允许多次助力" prop="ismutijoinass" class="distributionGrade">
                        <el-switch v-model="ruleForm.ismutijoinass" :disabled="isBegin || iscontinueassstatus"></el-switch>
                        <span class="inputTips">关闭时系统默认只允许1次</span>
                        <el-form-item label="多次助力类型" v-show="ruleForm.ismutijoinass === true">
                            <el-radio-group v-model="ruleForm.mutijoinasstype" :disabled="isBegin">
                                <el-radio :label="1">按活动 <span class="inputTips">指活动时间内可以助力多少次</span></el-radio>
                                <el-radio :label="2">按日 <span class="inputTips">指活动每天可以助力多少次</span></el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="最多助力次数" prop='maxjoinasscount' required v-show="ruleForm.ismutijoinass === true">
                            <el-input style="width: 100px" placeholder="填写整数" v-model="ruleForm.maxjoinasscount" :disabled="isBegin"></el-input>
                        </el-form-item>
                    </el-form-item>

                    <el-form-item label="关注后自动助力" v-if="ruleForm.asstype == 2">
                        <el-switch v-model="ruleForm.desautomakeass"></el-switch>
                        <span class="inputTips">开启时通过邀请关注公众号的用户会自动发起助力活动</span>
                    </el-form-item>
                    <!-- 公众号助力情况下显示 -->

                </div>
            </div>

            <div class="payVoucherMsgBox">
                <div class="title"><p>支付凭证</p></div>
                <div class="contentBox">
                    <div class="left">
                        <el-form-item prop="resulttype">
                            <el-radio-group v-model="ruleForm.resulttype">
                                <div class="noCondition">
                                    <el-radio v-model="ruleForm.resulttype" :label="1" :disabled="isBegin">普通型
                                        <span class="inputTips">选择该状态后只显示自定义内容</span>
                                    </el-radio>
                                </div>

                                <div class="cdkey">
                                    <el-radio v-model="ruleForm.resulttype" :label="3" :disabled="isBegin">兑换码</el-radio>
                                    <div class="uploadXlsBox" v-show="ruleForm.resulttype === 3">
                                        <div class="actionBox">
                                            <!-- <UploadFile :uploadType="uploadVideoType" @setFile="setFile" :fileRule="xlsRule"></UploadFile> -->
                                            <el-upload :on-exceed="handleExceed" :before-remove="beforeRemoveXls" class="upload-demo" :limit="1" :disabled="$route.query.eventinnerid ? true : false || ruleForm.resulttype !== 3" action="" :auto-upload="false" :on-change="handleImport" accept=".xls,.xlsx">
                                                <el-button type="success" :disabled="$route.query.eventinnerid ? true : false || ruleForm.resulttype !== 3">点击上传</el-button>
                                            </el-upload>
                                            <el-button class="download" @click="handleDownTemplate">下载模版</el-button>
                                        </div>
                                        <p class="uploadXlsTips">支持XLS、XLSX格式，用户购买后自动下发</p>
                                    </div>
                                </div>
                                <div class="code">
                                    <el-radio v-model="ruleForm.resulttype" :label="4" :disabled="isBegin">核销型</el-radio>
                                    <div class="codeTips">核销模式成功启用，提交后请在用户列表设置核销员</div>
                                </div>
                                <div class="code">
                                    <el-radio v-model="ruleForm.resulttype" :label="5" :disabled="isBegin">配送型
                                        <!-- disabled -->
                                        <span class="inputTips">选择配送型需发布方自行配送</span>
                                    </el-radio>
                                </div>
                                <div class="selfContent" v-show="ruleForm.resulttype !== 2">
                                    <uEditor :content="ruleForm.customcontent" ref="uEditor2" @getUEditorContent="getSelfContent"></uEditor>
                                </div>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="right">
                        <div class="topBox">
                            <img class="top" :src="require('@/common/images/toolmgt/view-top.png')" alt="">
                            <div class="tips">购买成功</div>
                        </div>
                        <div class="tipsContentBox">
                            <div class="innerBox">
                                <img v-if="ruleForm.resulttype !== 4" class="successTips" :src="require('@/common/images/toolmgt/pay_01.png')" alt="">
                                <img v-if="ruleForm.resulttype === 3" class="redeemCodeTips" :src="require('@/common/images/toolmgt/pay_02.png')" alt="">
                                <img v-if="ruleForm.resulttype === 4" class="destroyTips" :src="require('@/common/images/toolmgt/pay_03.png')" alt="">
                                <img v-if="ruleForm.resulttype === 4" class="codeTips" :src="require('@/common/images/toolmgt/pay_04.png')" alt="">
                                <div v-if="ruleForm.resulttype !== 2" class="selfContent" v-html="ruleForm.customcontent">此区域可进行自定义，用户在配置参数时，采用后台自带的富文本编辑器进行编辑支付后的凭证内容。</div>
                                <img v-if="ruleForm.resulttype === 5" class="codeTips" :src="require('@/common/images/communityPurchases/pztype-4.png')" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="posterSetBox">
                <div class="title"><p>海报设置</p></div>
                <div class="contentBox">
                    <div class="left">
                        <el-form-item label="海报图片" required class="posterImg" prop="postercoveratturlid">
                            <div class="imgBoxPoster">
                                <i class="el-icon-picture" v-if="!ruleForm.postercoveratturlidImg"></i>
                                <img class="activityCoverImagePoster" :src="ruleForm.postercoveratturlidImg.furl + '?' + time" v-else-if="ruleForm.postercoveratturlidImg && ruleForm.postercoveratturlidImg.furl + '?' + time" alt="">
                            </div>
                            <div class="uploadFileBox">
                                <UploadFile :uploadType="uploadVideoType" @setFile="setPosterFile" :fileRule="fileRule"></UploadFile>
                                <!-- <el-button @click.native="openPosterDialog">选择文件</el-button> -->
                                <p>建议尺寸750*1334px的JPG、PNG格式， 图片小于2M。</p>
                            </div>
                        </el-form-item>
                        <el-form-item label="邀请头像" prop="name">
                            <el-switch v-model="ruleForm.isdisplayheadimg"></el-switch>
                            <el-radio-group v-model="ruleForm.headimgstyle" :disabled='!ruleForm.isdisplayheadimg'>
                                <el-radio :label="1">圆形</el-radio>
                                <el-radio :label="2">方形</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="邀请昵称" prop="name" class="inviteImg">
                            <el-switch v-model="ruleForm.isdisplaynickname"></el-switch>
                            <el-color-picker v-model="ruleForm.nicknamecolor" :disabled="!ruleForm.isdisplaynickname"></el-color-picker>
                            <el-slider :min='12' v-model="ruleForm.nicknamesize" :disabled="!ruleForm.isdisplaynickname"></el-slider>
                        </el-form-item>
                        <el-form-item label="二维码" prop="name">
                            <el-switch v-model="ruleForm.isdisplayqrcode"></el-switch>
                        </el-form-item>
                    </div>
                    <div class="right">
                        <img :src="ruleForm.postercoveratturlidImg.furl + '?' + time" class="posterBg" v-if="(ruleForm.postercoveratturlidImg && ruleForm.postercoveratturlidImg.furl + '?' + time)" alt="">
                        <div @mousedown="moveHeadImg" :style="{top: ruleForm.headimgposition.split(',')[1] + 'px', left: ruleForm.headimgposition.split(',')[0] + 'px'}" :class="{'headImg': true, 'side': ruleForm.headimgstyle === 2, 'circle': ruleForm.headimgstyle === 1}" v-if="ruleForm.isdisplayheadimg">
                            头像
                        </div>
                        <div @mousedown="moveNickname" :style="{color: ruleForm.nicknamecolor ? ruleForm.nicknamecolor : '#303133', fontSize: ruleForm.nicknamesize + 'px', top: ruleForm.nicknameposition.split(',')[1]+'px', left: ruleForm.nicknameposition.split(',')[0]+'px'}" class="nickname" v-if="ruleForm.isdisplaynickname">用户昵称</div>
                        <div @mousedown="moveCode" v-show="ruleForm.isdisplayqrcode" class="rightCodeBox" :style="{top: ruleForm.qrcodeposition.split(',')[1]+'px', left: ruleForm.qrcodeposition.split(',')[0]+'px'}">
                            <div class="cover"></div>
                            <img class="serviceCode" :src="require('@/common/images/toolmgt/code.png')" alt="">
                        </div>
                        <!-- <img @mousedown="moveCode" class="serviceCode" v-if="ruleForm.isdisplayqrcode && ruleForm.qrcodeatturlid" :style="{top: ruleForm.qrcodeposition.split(',')[1]+'px', left: ruleForm.qrcodeposition.split(',')[0]+'px'}" :src="ruleForm.qrcodeatturlid.furl+'?'+time" alt=""> -->
                    </div>
                </div>
            </div>

            <div class="serviceSet payVoucherMsgBox">
                <div class="title"><p>客服二维码设置</p></div>
                <div class="contentBox">
                    <div style="margin-top: 20px">
                        <el-form-item label="客服二维码" required class="posterImg" prop="qrcodeatturlid">
                            <div class="imgBoxCode">
                                <i class="el-icon-picture" v-if="!ruleForm.qrcodeatturlidImg"></i>
                                <img class="activityCoverImage" :src="ruleForm.qrcodeatturlidImg.furl + '?' + time" v-else-if="ruleForm.qrcodeatturlidImg && ruleForm.qrcodeatturlidImg.furl + '?' + time" alt="">
                            </div>
                            <div class="uploadFileBox">
                                <UploadFile :uploadType="uploadVideoType" @setFile="setServiceFile" :fileRule="fileRule" ></UploadFile>
                                <!-- <el-button @click.native="openCodeDialog">选择文件</el-button> -->
                                <p>建议尺寸120*120px，JPG、PNG格式，图片小于100KB</p>
                            </div>
                        </el-form-item>
                        <el-form-item label="客服微信号" prop="servicempno">
                           <el-input v-model="ruleForm.servicempno" placeholder="输入客服微信号"></el-input>
                        </el-form-item>
                        <el-form-item label="客服说明" prop="servicedesp">
                           <el-input v-model="ruleForm.servicedesp" maxlength="20" show-word-limit placeholder="展示二维码下方，建议不超过20字"></el-input>
                        </el-form-item>
                        <el-form-item label="客服按钮" prop="servicebuttontext" class="inviteImg">
                            <el-input v-model="ruleForm.servicebuttontext" maxlength="6" show-word-limit placeholder="展示购买后首页客服按钮名称，建议不超过6字"></el-input>
                        </el-form-item>
                    </div>
                </div>
            </div>

            <div class="serviceSet payVoucherMsgBox">
                <div class="title"><p>排行榜设置</p></div>
                <div class="contentBox">
                    <div>
                        <el-form-item label="是否开启排行榜">
                            <el-switch v-model="ruleForm.isdisplayrank" @change="guanlian(2)" :disabled="iscontinueassstatus || ruleForm.iscontinueass == true && ruleForm.asstype !== 3"></el-switch>
                            <span class="inputTips">开启排行榜可以对助力活动进行排名，按助力发起人排名。</span>
                            <el-form-item label="是否开启奖品" v-show="ruleForm.isdisplayrank === true">
                                <el-switch v-model="ruleForm.isrankprize"></el-switch>
                                <span class="inputTips">开启奖品设置有利于助力推广</span>
                            </el-form-item>
                            <el-form-item label="奖品设置" prop="randprizedesp" v-show="ruleForm.isdisplayrank === true && ruleForm.isrankprize === true">
                                <el-input v-model="ruleForm.randprizedesp" class="textareaSet" type="textarea" placeholder="请填写奖品设置规则如： 排行榜第一名获得iPhone 11 手机一部； 排行榜第二至五名获得现金抵扣券； 排行榜第六至十名获得手持小风扇；"></el-input>
                            </el-form-item>
                        </el-form-item>
                    </div>
                </div>
            </div>
            <el-form-item class="btnBox">
                <el-button v-if="createsourcetype && ruleForm.status !== 30 && ruleForm.status !== 100" type="primary" @click="submitForm('ruleForm')">保存</el-button>
                <el-button @click="cancel">取消</el-button>
            </el-form-item>
        </el-form>
        <!-- <ShopLocalCropper :cropperOption="codeCropperOption" ref="codeLocalCropper" @setImage="_setCodeImage" :uploadType="uploadType"></ShopLocalCropper> -->
        <!-- <ShopLocalCropper :cropperOption="posterCropperOption" :size="'2'" ref="posterLocalCropper" @setImage="_setPosterImage" :uploadType="uploadType"></ShopLocalCropper> -->
        <ShopLocalCropper :cropperOption="cropperOption" ref="localCropper" @setImage="_setImage" :uploadType="uploadType"></ShopLocalCropper>
        <shopDistribution ref="shop"></shopDistribution>
    </div>
</template>
<script>
import UploadFile from 'base/upload/uploadFile2'
import UEditor from 'base/uEditor/uEditor2'
import shopDistribution from 'base/uEditor/dataComponents/shopDistribution.vue'
import {mapGetters, mapActions} from 'vuex'
import {computeFileSize} from 'common/js/tools'

import {saveOrUpdateAssEventInfo, getAssEventInfo} from 'api/taskToolsApi'
import {findAllMpaccount} from 'api/accountApi'

import ShopLocalCropper from 'base/cropper/shopLocalCropper'
import { format } from 'path'
export default {
    name: 'toolsActivityEdit',
    data() {
        let checkcoveratturlid = (rule, value, callback) => {
            if (this.ruleForm.coveratturlid) {
                callback()
            } else {
                callback('请上传活动主图')
            }
        }
        let checkdate = (rule, value, callback) => {
            let now = new Date().getTime()
            if (!this.ruleForm.begintime || !this.ruleForm.endtime) {
                if (!this.ruleForm.begintime) {
                    callback('请选择活动开始时间')
                } else if (!this.ruleForm.endtime) {
                    callback('请选择活动结束时间')
                }
            } else if (new Date(this.ruleForm.endtime).getTime() === new Date(this.ruleForm.begintime).getTime() || new Date(this.ruleForm.endtime).getTime() < new Date(this.ruleForm.begintime).getTime()) {
                callback('活动结束时间不能小于等于开始时间')
            } else {
                callback()
            }
        }
        let checkeventdesp = (rule, value, callback) => {
            if (this.ruleForm.eventdesp) {
                callback()
            } else {
                callback('请输入活动详情')
            }
        }
        // 检查商品原价
        let checksaleprice = (rule, value, callback) => {
            let numRegular = /^(([^0][0-9]+|0)\.([0-9]{1,2})$)|^(([^0][0-9]+|0)$)|^(([1-9]+)\.([0-9]{1,2})$)|^(([1-9]+)$)/

            // 砍价助力必须大于等于0
            if (this.ruleForm.asstype == 3) {
                if (this.ruleForm.saleprice < 0) {
                    callback('砍价助力商品原价必须大于或等于0')
                }
            }

            // 为0原价购买就关闭不能选择
            if (this.ruleForm.saleprice == 0) {
                this.ruleForm.isorgpricebuye = false
                this.isorgpricebuyeDisabled = true

                //  关闭继续助力 不按价格设置来确定是否继续助力
                // this.iscontinueassstatus = false
                // this.ruleForm.isdisplayrank = false
                // this.ruleForm.ismutijoinass = false

            } else {
                this.isorgpricebuyeDisabled = false

                // 启动继续助力
                // this.ruleForm.iscontinueass = false
                // this.ruleForm.isdisplayrank = false
                // this.iscontinueassstatus = true
                // this.ruleForm.ismutijoinass = false
            }


            if (!numRegular.test(this.ruleForm.saleprice)) {
                callback('请输入保留两位的数字')
            } else if (this.ruleForm.assprice && Number(this.ruleForm.assprice) > Number(this.ruleForm.saleprice)) {
                callback('商品价格需要大于助力价格')
            } else {
                callback()
            }
        }
        let checkuprice = (rule, value, callback) => {
            let numRegular = /^(([^0][0-9]+|0)\.([0-9]{1,2})$)|^(([^0][0-9]+|0)$)|^(([1-9]+)\.([0-9]{1,2})$)|^(([1-9]+)$)/
            if (!numRegular.test(this.ruleForm.assprice)) {
                callback('请输入保留两位的正数')
            } else if (Number(this.ruleForm.assprice) >= Number(this.ruleForm.saleprice) && Number(this.ruleForm.assprice) > 0) {
                callback('助力价格需要小于商品原价,且大于0')
            } else  {
                // if (this.ruleForm.assprice == 0) {
                //      this.iscontinueassstatus = false
                // } else {
                //     this.ruleForm.iscontinueass = false
                //     this.ruleForm.isdisplayrank = false
                //     this.iscontinueassstatus = true
                // }
                callback()
            }
        }
        let checkpostercoveratturlid = (rule, value, callback) => {
            if (this.ruleForm.postercoveratturlid) {
                callback()
            } else {
                callback('请上传海报图片')
            }
        }
        let checkqrcodeatturlid = (rule, value, callback) => {
            if (this.ruleForm.qrcodeatturlid) {
                callback()
            } else {
                // callback('请上传客服二维码')
                callback()
            }
        }

        let inputstockcount = (rule, value, callback) => {  // 商品总库存
            let numRegular = /^[+]{0,1}(\d+)$/
            if (!numRegular.test(this.ruleForm.stockcount)) {
                callback('请输入整数')
            }
            if (this.ruleForm.eventinnerid) {    // 如果设定了库存，编辑的时候只能增加不能减少
                if (this.lsStockount > this.ruleForm.stockcount) {
                    callback('库存数只能增加不能减少')
                }
            }
        }

        let inputmaxjoinasscount = (rule, value, callback) => { // 最多助力次数判断
            if (this.ruleForm.ismutijoinass == true) {
                if (this.ruleForm.maxjoinasscount == '') {
                    callback('请输入最多助力次数')
                } else {
                    let numRegular = /^[+]{0,1}(\d+)$/
                    if (!numRegular.test(this.ruleForm.maxjoinasscount)) {
                        callback('请输入整数')
                    }
                }
            }
        }


        let inputrandprizedesp = (rule, vaule, callback) => {   // 奖品设置
            if (this.ruleForm.isdisplayrank === true && this.ruleForm.isrankprize === true) {
                if (this.ruleForm.randprizedesp == '') {
                    callback('请输入奖品设置')
                }
            }
        }

        let inputservicempno = (rule, value, callback) => { // 公众号助力下必传
            if (this.ruleForm.asstype == 2) {
                if (!this.ruleForm.servicempno || this.ruleForm.servicempno == '') {
                    callback('请输入客服微信号')
                }
            }
        }

        return {
            disabled: false,
            isBegin: false,
            isorgpricebuyeDisabled: false,
            iscontinueassstatus: false,
            time: new Date().getTime(),
            formData: new FormData(),
            lsStockount: 0,
            maxcreateasscount: 0,
            joinappidList: [],
            fileInfo: '',
            createsourcetype: true,
            ruleForm: {
                asstype: this.$route.query.type,  // 助力类型：1阅读助力 2公众号助力 3砍价助力
                eventinnerid: this.$route.query.eventinnerid, // 活动innerid
                eventsource: 1, // 活动来源
                kmctype: '', // 内容类型
                kmcinnerid: '', // 内容innerid
                title: '', // 活动标题
                subtitle: '', // 活动副标题
                coveratturlid: '', // 活动Logo图 json串
                coveratturlidImg: '',
                begintime: '', // 活动开始时间
                endtime: '', // 活动结束时间
                stockcount: 0, // 商品总库存-0不限制
                eventdesp: '', // 活动详情
                isorgpricebuye: false, // 是否支持原价购买 0否 false 1是 true
                maxcreateasscount: 1,   // 可发起次数-0不限制
                assmoneytype: 1,   // 助力金额分配类型
                isfailbuy: false, // 未完成可差价购买 0否 1是
                saleprice: '', // 商品价格
                assprice: '', // 助力价格
                minasscount: 2, // 助力人数
                assexpiretype: 1,  // 	助力期限类型 1活动结束 2自定义
                assexpiretime: 48, // 助力期限-默认48小时
                ismutijoinass: false, // 是否允许多次助力 0否 1是
                mutijoinasstype: 1, // 多次助力数类型，1按活动 2按日
                maxjoinasscount: 0, // 最多助力次数
                joinappid: '', // 参与的公众号code
                desautomakeass: true, // 关注公众号之后是否自动生成助力 0否 1是
                iscontinueass: true, // 助力完成后继续助力 0否 1是
                resulttype: 1, // 支付凭证类型——1自定义  3兑换码 4核销码 5 配送型
                customcontent: '', // 支付自定义内容
                // importexcel: '',   // 兑换码Excel
                // posterinnerid: '', // 海报信息ID
                postercoveratturlid	: '', // 海报LOGO图(JSON串)
                postercoveratturlidImg: '',
                isdisplayheadimg: true, // 是否显示头像
                headimgstyle: 1, // 头像样式——1圆形 2方形
                headimgposition: '22,22', // 头像位置——格式X,Y
                isdisplaynickname: true, // 是否显示昵称
                nicknamecolor: '#000000', // 昵称字体颜色，带#
                nicknamesize: 12, // 昵称字体大小
                nicknameposition: '98,38', // 昵称位置——格式X,Y
                isdisplayqrcode: true, // 是否显示二维码
                qrcodeposition: '190,420', // 二维码位置——格式X,Y,
                code: '', // 兑换码——用逗号分隔
                qrcodeatturlid: '', // 客服二维码图(JSON串)
                qrcodeatturlidImg: '',
                servicedesp: '', // 客服说明
                servicebuttontext: '', // 客服按钮文字
                isdisplayrank: true, // 是否显示排行榜——0否 1是
                isrankprize: true, // 是否排行榜奖品 0否 1是
                randprizedesp: '', // 排行榜奖品说明
                date: '',
                createsourcetype: 1,    // 1pc 2小程序
                servicempno: '', // 客服微信号
                // fakesalecount: '', // 虚拟已售数量
            },
            rules: {
                coveratturlid: [
                    {validator: checkcoveratturlid, trigger: 'blur'}
                ],
                title: [
                    {required: true, message: '请输入活动标题', trigger: 'blur'},
                    {max: '40', message: '不超过40字',  trigger: 'blur'}
                ],
                subtitle: [
                    {max: '100', message: '不超过100字', trigger: 'blur'}
                ],
                // date: [
                //     {validator: checkdate, trigger: 'blur'}
                // ],
                eventdesp: [
                    {required: true, message: '请输入活动详情', trigger: 'blur'},
                    {validator: checkeventdesp, trigger: 'blur'}
                ],
                saleprice: [
                    {required: true, message: '请输入商品价格', trigger: 'blur'},
                    {validator: checksaleprice, trigger: 'blur'}
                ],
                assprice: [
                    {required: true, message: '请输入助力价格', trigger: 'blur'},
                    {validator: checkuprice, trigger: 'blur'}
                ],
                postercoveratturlid: [
                    {validator: checkpostercoveratturlid, trigger: 'blur'}
                ],
                qrcodeatturlid: [
                    {validator: checkqrcodeatturlid, trigger: 'blur'}
                ],
                servicedesp: [
                    {required: true, message: '请输入客服说明', trigger: 'blur'},
                    {max: 20, message: '20字以内', trigger: 'blur'}
                ],
                servicebuttontext: [
                    {required: true, message: '请输入客服按钮名称', trigger: 'blur'},
                    {max: 6, message: '6字以内', trigger: 'blur'}
                ],
                stockcount: [
                    {required: true, message: '请输入商品总库存', trigger: 'blur'},
                    {validator: inputstockcount, trigger: 'blur'}
                ],
                maxjoinasscount: [
                    {validator: inputmaxjoinasscount, trigger: 'blur'}
                ],
                randprizedesp: [
                    {validator: inputrandprizedesp, trigger: 'blur'}
                ],
                asstype: [
                    {required: true, message: '请选择公众号', trigger: 'blur'}
                ],
                begintime: [
                    {required: true, message: '请选择活动开始时间', trigger: 'blur'}
                ],
                endtime: [
                    {required: true, message: '请选择活动结束时间', trigger: 'blur'},
                    {validatoe: checkdate, trigger: 'blur'}
                ],
                servicempno: [
                    {validator: inputservicempno, trigger: 'blur'}
                ]

            },
            begintime: '',
            publicPath: process.env.BASE_URL,
            uploadVideoType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            cropperOption: {
                fixedNumber: [750, 420], // 截图框的宽高比例
                enlarge: 4.4, // 图片根据截图框输出比例倍数
                autoCropWidth: 170, // 默认生成截图框宽度
                autoCropHeight: 100 // 默认生成截图框高度
            },
            fileRule: {
                btnName: '选择文件',
                cls: '',
                accept: '.jpg,.jpeg,.png',
                size: 2,
                width: '750',
                height: '420'
            },
            xlsRule: {
                btnName: '点击上传',
                cls: '',
                accept: '.xls,.xlsx',
                size: 10,
                width: '',
                height: ''
            }
        }
    },
    created() {
    },
    mounted() {
        if (this.$route.query.eventinnerid) {
            this.getAssEventInfo()
        }
        if (this.$route.query.eventinnerid) {
            this.disabled = true
        }
        // if (this.ruleForm.asstype == 2) {
            // 公众号助力情况下使用
        this.findAllMpaccount()
        // }
    },
    methods: {
        handleExceed() {
            this.$message.warning('最多上传 1 个文件')
        },
        beforeRemoveXls() {
            this.formData = new FormData()
        },
        justMaxcreateasscount(value) {
            // 编辑情况下不为 0 的可发起次数只能增加不能减少
            if (this.ruleForm.eventinnerid) {
                if (value !== 0) {
                    if (parseInt(this.maxcreateasscount) > parseInt(value)) {
                        this.$message.error('可发起次数只能增加不能减少');
                        this.$nextTick(() => {
                            this.ruleForm.maxcreateasscount = this.maxcreateasscount
                        })
                    }
                }
            }
        },
        guanlian(type) {
            if (type == 1) {
                this.ruleForm.isdisplayrank = this.ruleForm.iscontinueass
            } else {
                // this.ruleForm.iscontinueass = this.ruleForm.isdisplayrank
            }
        },
        findAllMpaccount() {
            this.setLoading(true)
            findAllMpaccount({
                data: {},
                success: data => {
                    this.joinappidList = data.data
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        openCodeDialog() {
            this.$refs.codeLocalCropper.openDialog()
        },
        openPosterDialog() {
            this.$refs.posterLocalCropper.openDialog()
        },
        openDialog() {
            this.$refs.localCropper.openDialog()
        },
        _setCodeImage(file) {
            this.time = new Date().getTime()
            this.ruleForm.qrcodeatturlid = file
            this.ruleForm.qrcodeatturlidImg = file
        },
        _setPosterImage(file) {
            this.time = new Date().getTime()
            this.ruleForm.postercoveratturlid = file
            this.ruleForm.postercoveratturlidImg = file
        },
        _setImage(file) {
            this.time = new Date().getTime()
            this.ruleForm.coveratturlid = file
            this.ruleForm.coveratturlidImg = file
        },
        handleDownTemplate() {
            var link = document.createElement('a')
            link.href = `${this.publicPath}template/code.xls`
            link.download = 'code.xls'
            link.click() // 释放内存
            window.URL.revokeObjectURL(link.href)
        },
        gotogzh() {
            let newurl = this.$router.resolve({
                name: 'PublicNumberList'
            })
            window.open(newurl.href,'_blank')
        },
        choiceShop() {
            // this.$refs.shop.openDialog()
        },
        handleImport(file) {
            if (!this.$route.query.eventinnerid) {
                const fileInfo = file.raw
                // console.log('fileInfo',this.fileInfo)
                this.formData.append('importexcel', fileInfo)
                // this.ruleForm.importexcel = fileInfo
            } else {
                this.$message.error('编辑时不能修改兑换码')
            }
        },
        submitForm(formName) {
            let formData = JSON.parse(JSON.stringify(this.ruleForm))
            let exceldata=this.formData.get('importexcel')
            this.formData = new FormData()
            if(exceldata){
                this.formData.append('importexcel', exceldata)
            }

            // if (this.fileInfo !== '') {
            //     formData.importexcel = this.fileInfo
            //     consoel.log('formData',this.formData)
            // }
            if(formData.resulttype == 3 &&
                !this.$route.query.eventinnerid){
                if (!this.formData.get('importexcel')) {
                    this.$message.warning('兑换码文件不能为空')
                    return
                }
            }

            if (formData.asstype == 3 && formData.minasscount <= 1) {
                this.$message.error('助力人数需要大于1人')
                return
            }

            // bolear 与 0 1 转换
            this.justSwitchBoolear(['isorgpricebuye','isfailbuy','ismutijoinass','desautomakeass','iscontinueass','isdisplayheadimg',
                'isdisplaynickname','isdisplayqrcode','isdisplayrank','isrankprize'], 1, formData)

            // json 转换
            this.imgJson(['coveratturlid','postercoveratturlidImg','qrcodeatturlidImg',
            'qrcodeatturlid','coveratturlidImg','postercoveratturlid'],1,formData)


            if (!formData.kmctype) {
                formData.kmctype = ''
            }

            for (let key in formData) {
                this.formData.append(key, formData[key])
            }

            // if (this.formData.importexcel) {
            //     this.formData.importexcel = this.formData.importexcel.split(',{')[1]
            // }

            // console.log('formData',formData)
            // return

            this.setLoading(true)
            saveOrUpdateAssEventInfo({
                data: this.formData,
                success: data => {
                    this.setLoading(false)
                    this.$message.success('操作成功')

                    this.$router.push({name: 'TaskIndex'})
                },
                error: data => {
                    this.setLoading(false)
                    // if (data.msg === '兑换码文件内容错误') {
                    // this.formData = new FormData()
                    // }
                    this.$message.error(data.msg)
                }
            })
        },
        imgJson(array, type, data) {
            if (type == 1) {
                for (let item in data) {
                    for (let i = 0; i < array.length; i++) {
                        if (item === array[i]) {
                            if (data[item].furl)  {
                                delete data[item].type
                                data[item] = JSON.stringify(data[item])
                            }
                        }
                    }
                }
            }
        },
        cancel() {
            this.$router.push({name: 'TaskIndex'})
        },
        // 试看内容
        getTrySeeContent(content) {
            this.ruleForm.eventdesp = content
        },
        // 自定义内容
        getSelfContent(content) {
            this.ruleForm.customcontent = content
        },
        setFile(file) {
            computeFileSize()
            this.ruleForm.coveratturlid = file
            this.time = new Date().getTime()
        },
        setServiceFile(file) {
            computeFileSize()
            this.ruleForm.qrcodeatturlid = file
            this.ruleForm.qrcodeatturlidImg = file
            this.time = new Date().getTime()
        },
        setPosterFile(file) {
            computeFileSize()
            this.ruleForm.postercoveratturlid = file
            this.ruleForm.postercoveratturlidImg = file
            this.time = new Date().getTime()
        },
        // 移动头像
        moveHeadImg(e) {
            let odiv = e.target       //获取目标元素
            //算出鼠标相对元素的位置
            let disX = e.clientX - odiv.offsetLeft
            let disY = e.clientY - odiv.offsetTop
            document.onmousemove = (e)=>{       //鼠标按下并移动的事件
                //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                let left = e.clientX - disX
                let top = e.clientY - disY
                //移动当前元素
                if (left >= 0 && left < 250) {
                    odiv.style.left = left + 'px'
                    this.ruleForm.headimgposition = left + ',' + this.ruleForm.headimgposition.split(',')[1]
                }
                if (top >= 0 && top < 484) {
                    odiv.style.top = top + 'px'
                    this.ruleForm.headimgposition = this.ruleForm.headimgposition.split(',')[0] + ',' + top
                }
            }
            document.onmouseup = (e) => {
                document.onmousemove = null
                document.onmouseup = null
            }
        },
        // 移动昵称
        moveNickname(e) {
            let odiv = e.target       //获取目标元素
            //算出鼠标相对元素的位置
            let disX = e.clientX - odiv.offsetLeft
            let disY = e.clientY - odiv.offsetTop
            document.onmousemove = (e)=>{       //鼠标按下并移动的事件
                //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                let left = e.clientX - disX
                let top = e.clientY - disY
                //移动当前元素
                if (left >= 0 && left < 248) {
                    odiv.style.left = left + 'px'
                    this.ruleForm.nicknameposition = left + ',' + this.ruleForm.nicknameposition.split(',')[1]
                }
                if (top >= 0 && top < 520) {
                    odiv.style.top = top + 'px'
                    this.ruleForm.nicknameposition = this.ruleForm.nicknameposition.split(',')[0] + ',' + top
                }
            }
            document.onmouseup = (e) => {
                document.onmousemove = null
                document.onmouseup = null
            }
        },
        // 移动二维码
        moveCode(e) {
            let odiv = e.target.parentElement       //获取目标元素
            //算出鼠标相对元素的位置
            let disX = e.clientX - odiv.offsetLeft
            let disY = e.clientY - odiv.offsetTop
            document.onmousemove = (e)=>{       //鼠标按下并移动的事件
                //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                let left = e.clientX - disX
                let top = e.clientY - disY
                //移动当前元素
                if (left >= 0 && left < 219) {
                    odiv.style.left = left + 'px'
                    this.ruleForm.qrcodeposition = left + ',' + this.ruleForm.qrcodeposition.split(',')[1]
                }
                if (top >= 0 && top < 454) {
                    odiv.style.top = top + 'px'
                    this.ruleForm.qrcodeposition = this.ruleForm.qrcodeposition.split(',')[0] + ',' + top
                }
            }
            document.onmouseup = (e) => {
                document.onmousemove = null
                document.onmouseup = null
            }
        },
        // boolear 进行  true false 与 1 0 转换
        justSwitchBoolear (array, type, data) {
            let form = []

            if (data) {
                form = data
            }
           for (let item in form) {
               console.log(item)
                for (let i = 0; i < array.length; i++) {

                    if (item === array[i]) {
                         // 判断类型 数字和布尔互转
                        if (type === 1) {
                            form[item] = form[item] === true ? 1 : 0
                        } else {
                            form[item] = form[item] === 1 ? true : false
                        }
                    }

                }
           }

        },
        getAssEventInfo() {
            this.setLoading(true)
            getAssEventInfo({
                data: {eventinnerid: this.$route.query.eventinnerid},
                success: data => {
                    this.setLoading(false)

                    // data.data.date = [data.data.begintime, data.data.endtime]
                    this.justSwitchBoolear(['isorgpricebuye','isfailbuy','ismutijoinass','desautomakeass','iscontinueass','isdisplayheadimg',
                    'isdisplaynickname','isdisplayqrcode','isdisplayrank','isrankprize'], 2, data.data)

                    // if (data.data.isdisplayrank) {
                    //     data.data.isdisplayrank = true
                    // } else {
                    //     data.data.isdisplayrank = false
                    // }
                    // if (data.data.isdisplayheadimg) {
                    //     data.data.isdisplayheadimg = true
                    // } else {
                    //     data.data.isdisplayheadimg = false
                    // }
                    // if (data.data.isdisplaynickname) {
                    //     data.data.isdisplaynickname = true
                    // } else {
                    //     data.data.isdisplaynickname = false
                    // }
                    // if (data.data.isdisplayqrcode) {
                    //     data.data.isdisplayqrcode = true
                    // } else {
                    //     data.data.isdisplayqrcode = false
                    // }

                    // this.begintime = data.data.begintime
                    if (new Date(data.data.begintime).getTime() <= new Date().getTime()) {
                        this.isBegin = true
                    }


                    data.data.nicknamesize = Number(data.data.nicknamesize)
                    this.ruleForm = data.data
                    this.ruleForm.coveratturlidImg = this.ruleForm.coveratturlid
                    this.ruleForm.postercoveratturlidImg = this.ruleForm.postercoveratturlid
                    this.ruleForm.qrcodeatturlidImg = this.ruleForm.qrcodeatturlid
                    
                    if (this.ruleForm.createsourcetype === 2) {
                        this.$nextTick(() => {
                            this.createsourcetype = false
                            console.log('createsourcetype', this.createsourcetype)

                        })
                    }

                    this.lsStockount = this.ruleForm.stockcount
                    this.maxcreateasscount = this.ruleForm.maxcreateasscount

                    if (this.ruleForm.saleprice == 0) {
                        this.ruleForm.isorgpricebuye = false
                        // this.isorgpricebuyeDisabled = true
                    }
                    // else {
                    //     this.isorgpricebuyeDisabled = false
                    // }
                    this.isorgpricebuyeDisabled = true


                    // this.$nextTick(() =>{
                        if (this.ruleForm.resulttype !== 2) {
                            this.$refs.uEditor2.init(this.ruleForm.customcontent)
                            // console.log(222)
                        }
                        this.$refs.uEditor1.init(this.ruleForm.eventdesp)
                    // })
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    watch: {
        // 'ruleForm.date': {
        //     handler(newV) {
        //         if (this.$route.query.eventinnerid) {
        //             this.ruleForm.date[0] = this.begintime
        //         }
        //     }
        // }
    },
    components: {
        UploadFile, UEditor, shopDistribution, ShopLocalCropper
    }
}
</script>
<style lang="scss">
@import "~common/scss/mixin";
@import "~common/scss/base";
    .toolsActivityEdit{
        background: #F5F7FA;
        min-width: 1200px;
        .title{
            padding-bottom: 20px;
            border-bottom: 1px solid #DCDFE6;
            p{
                border-left: 2px solid #409EFF;
                text-indent: 8px;
                font-size: 16px;
                font-weight: 500;
            }
        }
        .shareTitle{
            border: none;
        }
        .el-form{
            .el-form-item {
                .el-form-item__label{
                    text-align: left;
                    font-size: 14px;
                }
            }
            .inputTips{
                color: #C0C4CC;
                margin-left: 10px;
            }
            .imgBoxCode {
                float: left;
                margin-right: 30px;
                width: 120px;
                height: 120px;
                font-size: 64px;
                text-align: center;
                line-height: 120px;
                color: #DCDFE6;
                background: #F5F7FA;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .uploadFileBox {
                float: left;
                margin-top: 25px;
            }
        }
        .activityMsgBox{
            .left{
                min-width: 826px;
            }
        }
        .shareSet{
            .contentBox{
                display: block !important;
                .shareImg{
                    .el-form-item__content{
                        display: flex;
                        align-items: center;
                        .imgBoxCode{
                            width: 178px;
                            height: 178px;
                            background: #F5F7FA;
                            text-align: center;
                            line-height: 178px;
                            .el-icon-picture{
                                color: #DCDFE6;
                                font-size: 40px;
                            }
                            .activityShareImage{
                                width: 178px;
                                height: 178px;
                            }
                        }
                        .uploadFileBox{
                            margin-left: 12px;
                            .uploadFile{
                                .el-upload{
                                    .el-button{
                                        background: #fff;
                                        border-color: #C0C4CC;
                                        span{
                                            color: #000;
                                        }
                                    }
                                }
                            }
                            p{
                                color: #909399;
                            }
                        }
                    }
                }
                .el-textarea{
                    width: 400px;
                    .el-textarea__inner{
                        width: 400px;
                    }
                }
            }
        }
        .activityMsgBox, .posterSetBox{
            background: #fff;
            padding: 20px;
            margin-bottom: 24px;
            .contentBox{
                padding-top: 20px;
                display: flex;
                // justify-content: space-between;
                .left{
                    .cover,.posterImg{
                        .el-form-item__content{
                            display: flex;
                            align-items: center;
                            .imgBox{
                                width: 318px;
                                height: 178px;
                                background: #F5F7FA;
                                text-align: center;
                                line-height: 178px;
                                .el-icon-picture{
                                    color: #DCDFE6;
                                    font-size: 40px;
                                }
                                .activityCoverImage{
                                    width: 318px;
                                    height: 178px;
                                }
                            }
                            .uploadFileBox{
                                margin-left: 12px;
                                .uploadFile{
                                    .upload-demo{
                                        .el-upload {
                                            .el-button{
                                                background: #fff;
                                                color: #000;
                                                border: 1px solid #C0C4CC;
                                            }
                                        }
                                    }
                                }
                                p{
                                    color: #909399;
                                    font-size: 14px;
                                    line-height: 20px;
                                }
                            }
                        }
                    }
                    .el-form-item{
                        .el-form-item__content{
                            .el-input{
                                width: 400px;
                            }
                            .el-date-editor{
                                .el-input__icon, .el-range-separator{
                                    line-height: 25px;
                                }
                            }
                            .mostTips{
                                color: #C0C4CC;
                            }
                            .showRankingListTips{
                                color: #909399;
                                margin-left: 20px;
                                position: relative;
                                top: 2px;
                            }
                        }
                    }
                    .date{
                        .el-form-item__label::after{
                            content: '*';
                            color: #F56C6C;
                            margin-left: 4px;
                        }
                        .el-form-item__content{
                            width: 500px;
                            .to{
                                margin: 0 13px;
                            }
                            .el-date-editor {
                                width: 180px;
                                .el-input__inner{
                                    padding-right: 0;
                                }
                            }
                        }
                    }
                }
                .right{
                    width: 300px;
                    height: 534px;
                    background:rgba(242,246,252,1);
                    box-shadow:0px 0px 8px 0px rgba(0,0,0,0.3);
                    overflow: hidden;
                    margin-left: 30px;
                    .innerBox{
                        width: 320px;
                        height: 482px;
                        overflow-y: scroll;
                    }
                    .topBox{
                        height: 52px;
                        .top{
                            width: 300px;
                            height: 52px;
                        }
                    }
                    .coverImgBox{
                        background: #DCDCDC;
                        width: 300px;
                        height: 168px;
                        .activityCoverImage{
                            width: 300px;
                            height: 168px;
                        }
                    }
                    .priceBox{
                        height: 60px;
                        background: #fff;
                        border-bottom: 1px solid #f5f5f5;
                        padding: 7px 12px;
                        box-sizing: border-box;
                        .price{
                            color: #F56C6C;
                            margin-top: 5px;
                        }
                        .outofprint{
                            color: #909399;
                            margin-top: 10px;
                        }
                    }
                    .rightTitleBox{
                        // height: 60px;
                        background: #fff;
                        padding: 7px 12px;
                        box-sizing: border-box;
                        .rightTitle{
                            margin-top: 5px;
                        }
                        .rightSubtitle{
                            color: #909399;
                            margin-top: 10px;
                        }
                    }
                    .detailsBox{
                        margin-top: 10px;
                        .detailsTitle{
                            background: #fff;
                            padding-left: 12px;
                            height: 40px;
                            line-height: 40px;
                            border-bottom: 1px solid #f5f5f5;
                        }
                        .detailsContent{
                            background: #fff;
                            padding: 12px;
                            p{
                                line-height: 15px;
                            }
                            img{
                                width: 100%;
                            }
                        }
                    }
                }
            }
        }
        .distributionMsgBox{
            background: #fff;
            padding: 20px;
            margin-bottom: 24px;
            .contentBox{
                margin-top: 20px;
                .earnings{
                    .el-form-item__content{
                        margin-left: 0 !important;
                        .one{
                            margin-bottom: 15px;
                        }
                        .el-form-item{
                            .el-form-item__content{
                                .el-input {
                                    margin-top: 5px;
                                }
                                .el-form-item__error{
                                    left: 120px;
                                }
                            }
                        }
                    }
                }
                .el-form-item{
                    .el-form-item__content{
                        .el-input{
                            width: 400px;
                        }
                        .bindclienttypeTips{
                            color: #909399;
                            line-height: 20px;
                        }
                    }
                }
                .distributionGrade{
                    .el-form-item__content{
                        .el-input-number{
                            width: 100px;
                            line-height: 32px;
                            .el-input-number__decrease,.el-input-number__increase{
                                width: 30px;
                                height: 30px;
                                border: none;
                                background: #409EFF;
                                color: #fff;
                            }
                            .el-input{
                                width: 100px;
                                .el-input__inner{
                                    padding: 0;
                                }
                            }
                        }
                    }
                }
            }
        }
        .payVoucherMsgBox{
            background: #fff;
            padding: 20px;
            margin-bottom: 24px;
            .contentBox{
                display: flex;
                // justify-content: space-between;
                .left{
                    // width: 970px;
                    .el-form-item__content{
                        margin-left: 10px !important;
                        .el-radio-group{
                            padding-top: 20px;
                            .noCondition{
                                // height: 32px;
                            }
                            .cdkey{
                                margin-top: 10px;
                                .uploadXlsBox{
                                    .uploadXlsTips{
                                        margin-top: 10px;
                                    }
                                }
                            }
                        }
                        .el-radio{
                            width: 90px;
                        }
                        .noCondition{
                            .tips{
                                color: #C0C4CC;
                            }
                        }
                        .buyDistribution{
                            margin-top: 10px;
                            .el-input{
                                width: 520px;
                            }
                        }
                        .cdkey{
                            display: flex;
                            margin-top: 10px;
                            min-height: 40px;
                            .el-radio{
                                position: relative;
                                top: 5px;
                            }
                            .uploadXlsBox{
                                .actionBox{
                                    display: flex;
                                    .uploadFile{
                                        .upload-demo{
                                            .el-upload {
                                                .el-button {
                                                    background: #67C23A;
                                                    border: 1px solid #67C23A;
                                                }
                                            }
                                        }
                                    }
                                    .download{
                                        margin-left: 34px;
                                        color: #409EFF;
                                        cursor: pointer;
                                        border: none;
                                    }
                                    .download:hover {
                                        background: #fff
                                    }
                                }
                                .uploadXlsTips{
                                    color: #C0C4CC;
                                    font-size: 12px;
                                }
                            }
                        }
                        .code{
                            margin-top: 10px;
                            display: flex;
                            align-items: center;
                            .codeTips{
                                width: 400px;
                                background: #F56C6C;
                                line-height: 32px;
                                color: #fff;
                                border-radius:4px;
                                text-indent: 26px;
                                font-size: 14px;
                            }
                        }
                        .selfContent{
                            margin-top: 20px;
                        }
                    }
                }
                .right{
                    margin-top: 50px;
                    width: 300px;
                    height: 534px;
                    background: #F2F6FC;
                    box-shadow:0px 0px 8px 0px rgba(0,0,0,0.3);
                    margin-left: 130px;
                    .topBox{
                        width: 300px;
                        height: 52px;
                        position: relative;
                        .top{
                            width: 300px;
                            height: 52px;
                        }
                        .tips{
                            position: absolute;
                            width: 224px;
                            bottom: 10px;
                            text-align: center;
                            left: 40px;
                            font-weight: 500;
                        }
                    }
                    .tipsContentBox{
                        width: 300px;
                        height: 482px;
                        overflow: hidden;
                        .innerBox{
                            width: 320px;
                            height: 482px;
                            overflow-y: scroll;
                        }
                        .successTips{
                            width: 300px;
                            height: 104px;
                        }
                        .redeemCodeTips{
                            width: 300px;
                            height: 40px;
                        }
                        .destroyTips{
                            width: 300px;
                            height: 105px;
                        }
                        .codeTips{
                            width: 300px;
                            height: 150px;
                        }
                        .selfContent{
                            padding: 16px 12px;
                            background: #fff;
                            line-height: 20px;
                        }
                    }
                }
            }

        }
        .posterSetBox{
            background: #fff;
            .contentBox{
                .left{
                    width: 801px;
                    .el-form-item{
                        .el-switch{
                            margin-right: 30px;
                        }
                    }
                    .imgBoxPoster{
                        width: 178px;
                        height: 317px;
                        background: #F5F7FA;
                        text-align: center;
                        line-height: 317px;
                        .el-icon-picture{
                            color: #DCDFE6;
                            font-size: 40px;
                        }
                        .activityCoverImagePoster{
                            width: 178px;
                            height: 317px;
                        }
                    }
                    .inviteImg{
                        .el-form-item__content{
                            display: flex;
                            align-items: center;
                            .el-color-picker {
                                width: 16px;
                                height: 16px;
                                margin-right: 28px;
                                .el-color-picker__trigger{
                                    padding: 0;
                                    width: 16px;
                                    height: 16px;
                                }
                            }
                            .el-slider{
                                width: 160px;
                                display: inline-block;
                            }
                        }
                    }
                    .serviceSet{
                        .title{
                            border-bottom: none;
                        }
                        .imgBoxCode{
                            width: 178px;
                            background: #F5F7FA;
                            text-align: center;
                            line-height: 178px;
                            height: 178px;
                            .el-icon-picture{
                                color: #DCDFE6;
                                font-size: 40px;
                            }
                            .activityCoverImage{
                                width: 178px;
                                height: 178px;
                            }
                        }
                    }
                }
                .right{
                    margin-left: 30px;
                    position: relative;
                    .posterBg{
                        width: 300px;
                        height: 534px;
                    }
                    .headImg{
                        width: 48px;
                        height: 48px;
                        background: #D8D8D8;
                        border: 1px solid #979797;
                        text-align: center;
                        line-height: 48px;
                        position: absolute;
                        cursor: move;
                    }
                    .side{
                        border-radius: 0;
                    }
                    .circle{
                        border-radius: 50%;
                    }
                    .nickname{
                        position: absolute;
                        cursor: move;
                    }
                    .rightCodeBox{
                        cursor: move;
                        position: absolute;
                        .cover{
                            width: 80px;
                            height: 80px;
                            position: absolute;
                        }
                        img{
                            width: 80px;
                            height: 80px;
                        }
                    }
                }
            }
        }
        .el-radio__input.is-checked+.el-radio__label{
            color: #303133;
        }
        .btnBox{
            .el-form-item__content{
                margin-left: 0 !important;
                text-align: center;
                background: #fff;
                height: 80px;
                line-height: 80px;
            }
        }
        .textareaSet {
            width: 400px;
            height: 117px;
            textarea {
                width: 100%;
                height: 100%;
            }
        }
    }
</style>
